<template>
  <!-- 過去受付一覧ダイアログ -->
  <v-dialog v-model="showDialog" width="90vw" persistent no-click-animation scrollable>
    <v-card>
      <v-toolbar elevation="2" color="#2F75B5" dark dense>
        <v-spacer></v-spacer>
        <v-toolbar-title>過去作業一覧</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="onCloseButtonClick" text><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <v-container fluid>

          <v-row no-gutters>
            <v-col :cols="12">
              <dd-sub-header>
                検索条件
              </dd-sub-header>
              <span class="ml-1 view-description"><v-icon color="green" small>mdi-information-outline</v-icon>登録済み作業を絞り込みたい条件を入力して[検索実行]を押下してください。</span>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col :cols="3">
              <v-row no-gutters>
                <v-col :cols="12" class="px-1">
                  <dd-code-text-box
                    label="得意先コード/名称"
                    v-model="conditions.tokuisakiId"
                    ref="tokuisakiId"
                    :length="100"
                    :valueType="Ctrls.InputTypes.Free"
                    titleText="得意先検索"
                    item-value="torihikisakiCd"
                    item-text="torihikisakiNm"
                    returnValueName="id"
                    :headerList="headersTorihikisakiList"
                    :itemList="filteredTokuisakiList"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="3">
              <v-row no-gutters>
                <v-col :cols="12" class="px-1">
                  <dd-text-box
                    label="取付先"
                    v-model="conditions.toritsukesaki"
                    ref="toritsukesakiNm"
                    :length="50"
                    :valueType="Ctrls.InputTypes.Free"
                  />
                </v-col>
              </v-row>
            </v-col>
            <v-col :cols="6">
              <v-row no-gutters>
                <v-col :cols="12" class="px-1">
                  <v-row no-gutters justify="end">
                    <dd-custom-button
                      color="#2196F3"
                      :rounded="false"
                      :minWidth="100"
                      tooltipText="入力された検索条件で登録済み受付を検索します"
                      :enableToolTip="helpUseFlg"
                      :tooltipBottom="true"
                      @click="onSearchButtonClick">
                      検索実行
                    </dd-custom-button>

                    <dd-custom-button
                      color="#2196F3"
                      :rounded="false"
                      :minWidth="100"
                      tooltipText="入力された検索条件と一覧をクリアします"
                      :enableToolTip="helpUseFlg"
                      :tooltipBottom="true"
                      @click="onClearButtonClick">
                      クリア
                    </dd-custom-button>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col :cols="6">
              <dd-sub-header>
                検索結果一覧
              </dd-sub-header>
              <span v-if="filteredRows.length > 0" class="ml-1 view-description"><v-icon color="green" small>mdi-information-outline</v-icon>対象行をチェックして[選択]を押下するか、ダブルクリックで呼び出し元画面に反映します。</span>
            </v-col>
            <v-col :cols="1"></v-col>
            <v-col :cols="3">
              <dd-narrow-down-text-box
                v-model="searchText"
                :length="50"
              />
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="検索結果"
                v-model="rowCount"
              />
            </v-col>
            <v-col :cols="1">
              <dd-row-count-box
                label="絞込結果"
                v-model="filteredRowCount"
              />
            </v-col>
          </v-row>

          <v-row no-gutters>
            <v-col :cols="12" class="px-1">
              <dd-data-table
                calculate-widths
                item-key="trJuchuMeisaiId"
                :headers="headers"
                :items="filteredRows"
                height="50vh"
                fixed-header
                locale="ja-jp"
                :search="searchText"
                no-data-text="利用可能なデータはありません。"
                hide-default-footer
                @dblclick:row="onRowDoubleClick"
                dense
              >
                <template v-slot:[`item.actions`]="{item}">
                  <template>
                    <v-chip
                      small
                      color="primary"
                      @click="onRowSelectButtonClick(item)"
                    >
                      選択
                    </v-chip>
                  </template>
                </template>
              </dd-data-table>
            </v-col>
          </v-row>

        </v-container>
      </v-card-text>
      <v-card-actions>
        <dd-footer-button
          @click="onCloseButtonClick"
          tooltipText="この画面を終了して前の画面へ戻ります"
          :tooltipTop="true"
          :enableToolTip="helpUseFlg">
          <v-icon>mdi-window-close</v-icon>
          閉じる
        </dd-footer-button>
        <v-spacer/>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>
<script>
import DdSubHeader from '@/components/DdSubHeader'
import DdFooterButton from '@/components/DdFooterButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdDataTable from '@/components/DdDataTable'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdCustomButton from '@/components/DdCustomButton'
import DdRowCountBox from '@/components/DdRowCountBox'
// import DdIconButtonWithTooltip from '@/components/DdIconButtonWithTooltip'
import DdTextBox from '@/components/DdTextBox'

import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import header from '@/ddv2.library/header'
import modals from '@/ddv2.library/modals'

import { mapGetters } from 'vuex'

export default {
  name: 'tgPopupUketsukeSearchDialog',
  mixins: [flowMixin],
  components: {
    DdSubHeader,
    DdFooterButton,
    DdNarrowDownTextBox,
    DdDataTable,
    DdCodeTextBox,
    DdCustomButton,
    DdRowCountBox,
    // DdIconButtonWithTooltip,
    DdTextBox
  },
  props: {
    /**
     * 受注明細ID
     */
    id: {
      type: Number,
      default: 0
    },
    /**
     * 検索用初期項目
     */
    item: {
      type: Object
    },
    /**
     * 画面表示フラグ
     */
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    searchText: '',
    rows: [],
    conditions: {
      tokuisakiId: null,
      toritsukesakiNm: null,
      excludeId: null
    },

    juchuMeisaiId: 0,
    showPastUketsukeDialog: false,

    // ヘッダー
    headersTorihikisakiList: header.mstTorihikisakiHeaders,
    headers: [
      { text: '', value: 'actions', width: '15px' },
      { text: '作業予定日FROM', value: 'hatsuchiYmdDisp', align: 'center' },
      { text: '作業予定日TO', value: 'chakuchiYmdDisp', align: 'center' },
      { text: '得意先名称', value: 'tokuisakiNm' },
      { text: '取付先', value: 'toritsukesaki' },
      { text: '営業所', value: 'denpyoBiko1' },
      { text: 'ジャンル', value: 'genreNm' },
      { text: '客先注文番号', value: 'chumonNo' },
      { text: '作業区分', value: 'sagyoKbnNm' },
      { text: '商品', value: 'shohinNm' },
      { text: '依頼台数', value: 'iraiDaisu' },
      { text: '受付担当者', value: 'uketsukeTantoshaNm' },
      { text: '受付日', value: 'juchuYmdDisp', align: 'center' },
      { text: '取付先 郵便番号', value: 'toritsukesakiYubinNo' },
      { text: '取付先 住所1', value: 'toritsukesakiJusho1' },
      { text: '取付先 住所2', value: 'toritsukesakiJusho2' },
      { text: '電話番号', value: 'denpyoBiko3' },
      { text: '電話番号2', value: 'toritsukesakiJusho3' },
      { text: '作業場所 郵便番号', value: 'sagyobashoYubinNo' },
      { text: '作業場所 住所1', value: 'sagyobashoJusho1' },
      { text: '作業場所 住所2', value: 'sagyobashoJusho2' },
      { text: '作業場所 住所3', value: 'sagyobashoJusho3' }
    ]
  }),
  created () {
  },
  mounted () {
    this.clear()
  },
  computed: {
    ...mapGetters({
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      shubetsuList: 'DDMasters/mstShubetsu',
      kubunList: 'DDMasters/msysKubun',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    computedProps () {
      return {
        ...this.$props,
        persistent: true
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    },
    filteredRows () {
      return this.rows.map((elem) => {
        // 表示フォーマット編集
        const elem2 = { ...elem }
        elem2.juchuYmdDisp = elem.juchuYmd ? filter.dateFormatter(elem.juchuYmd) : ''
        elem2.iraiDaisuDisp = elem.iraiDaisu === null || elem.iraiDaisu === undefined ? '' : filter.numericFormatter(elem.iraiDaisu)
        elem2.sagyoNaiyoKakuteiYmdDisp = elem.sagyoNaiyoKakuteiYmd ? filter.dateFormatter(elem.sagyoNaiyoKakuteiYmd) : ''
        elem2.unchinCheckYmdDisp = elem.unchinCheckYmd ? filter.dateFormatter(elem.unchinCheckYmd) : ''
        elem2.hatsuchiYmdDisp = elem.hatsuchiYmd ? filter.dateFormatter(elem.hatsuchiYmd) : ''
        elem2.chakuchiYmdDisp = elem.chakuchiYmd ? filter.dateFormatter(elem.chakuchiYmd) : ''
        elem2.seikyuYoteiYmdDisp = elem.seikyuYoteiYmd ? filter.dateFormatter(elem.seikyuYoteiYmd) : ''
        elem2.mitsumoriSagyoKingakuKeiDisp = elem.mitsumoriSagyoKingakuKei === null || elem.mitsumoriSagyoKingakuKei === undefined ? '' : filter.numericFormatter(elem.mitsumoriSagyoKingakuKei)
        elem2.mitsumoriBuzaiKingakuKeiDisp = elem.mitsumoriBuzaiKingakuKei === null || elem.mitsumoriBuzaiKingakuKei === undefined ? '' : filter.numericFormatter(elem.mitsumoriBuzaiKingakuKei)
        elem2.mitsumoriChoseiKingakuDisp = elem.mitsumoriChoseiKingaku === null || elem.mitsumoriChoseiKingaku === undefined ? '' : filter.numericFormatter(elem.mitsumoriChoseiKingaku)
        elem2.mitsumoriChoseiKomiKingakuKeiDisp = elem.mitsumoriChoseiKomiKingakuKei === null || elem.mitsumoriChoseiKomiKingakuKei === undefined ? '' : filter.numericFormatter(elem.mitsumoriChoseiKomiKingakuKei)
        elem2.seikyuSagyoKingakuKeiDisp = elem.seikyuSagyoKingakuKei === null || elem.seikyuSagyoKingakuKei === undefined ? '' : filter.numericFormatter(elem.seikyuSagyoKingakuKei)
        elem2.seikyuBuzaiKingakuKeiDisp = elem.seikyuBuzaiKingakuKei === null || elem.seikyuBuzaiKingakuKei === undefined ? '' : filter.numericFormatter(elem.seikyuBuzaiKingakuKei)
        elem2.seikyuChoseiKingakuDisp = elem.seikyuChoseiKingaku === null || elem.seikyuChoseiKingaku === undefined ? '' : filter.numericFormatter(elem.seikyuChoseiKingaku)
        elem2.seikyuChoseiKomiKingakuKeiDisp = elem.seikyuChoseiKomiKingakuKei === null || elem.seikyuChoseiKomiKingakuKei === undefined ? '' : filter.numericFormatter(elem.seikyuChoseiKomiKingakuKei)
        elem2.shiharaiKingakuKeiDisp = elem.shiharaiKingakuKei === null || elem.shiharaiKingakuKei === undefined ? '' : filter.numericFormatter(elem.shiharaiKingakuKei)
        elem2.shiharaiChoseiKingakuKeiDisp = elem.shiharaiChoseiKingakuKei === null || elem.shiharaiChoseiKingakuKei === undefined ? '' : filter.numericFormatter(elem.shiharaiChoseiKingakuKei)
        elem2.shiharaiChoseiKomiKingakuKeiDisp = elem.shiharaiChoseiKomiKingakuKei === null || elem.shiharaiChoseiKomiKingakuKei === undefined ? '' : filter.numericFormatter(elem.shiharaiChoseiKomiKingakuKei)
        return elem2
      })
    },
    // ドロップダウン
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter((elem) => {
        return elem.tokuisakiFlg === true && elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.torihikisakiCd > elem2.torihikisakiCd) { return 1 }
        if (elem1.torihikisakiCd === elem2.torihikisakiCd) { return 0 }
        return -1
      })
    }
  },
  watch: {
    showDialog: function () {
      if (this.showDialog) {
        this.conditions.tokuisakiId = this.item.tokuisakiId
        this.conditions.toritsukesakiNm = this.item.toritsukesakiNm
        this.conditions.excludeId = this.id
      }
    }
  },
  methods: {
    clear: function () {
      this.rows = []
      this.conditions = {
        tokuisakiId: null,
        toritsukesakiNm: null,
        excludeId: this.id
      }
    },
    search: function () {
      const self = this
      this.Effects.loadStart()
      return new Promise((resolve) => {
        self.HttpClient
          .post('/api/v1/vwCTgrcod0011/Search', self.conditions)
          .then((data) => {
            console.log('search', data)
            if (data.isValid) {
              self.rows = data.payload
            }
            this.Effects.loadComplete()
            resolve()
          }).catch((e) => {
            console.log('error', e)
            modals.showError(e.message)
            this.Effects.loadComplete()
          })
      })
    },
    onSearchButtonClick: function () {
      this.search()
    },
    onClearButtonClick: function () {
      this.clear()
    },
    onRowClick: function (header, item) {
      if (header !== 'actions') {
        this.juchuMeisaiId = item.trJuchuMeisaiId
        this.showPastUketsukeDialog = true
      }
    },
    onRowSelectButtonClick: function (item) {
      console.log('onRowSelectButtonClick', item)
      this.syncCallBackView(item)
    },
    onRowDoubleClick: function (e, f) {
      this.syncCallBackView(f.item)
    },
    onCloseButtonClick: function (e) {
      this.$emit('close', null)
      this.clear()
    },

    // 呼び出し元画面への反映
    syncCallBackView: function (e) {
      const self = this
      return new Promise((resolve) => {
        self.Effects.loadStart()
        self.HttpClient
          .get(`/api/v1/Tgrcod0021/FindByJuchuMeisaiId?id=${e.trJuchuMeisaiId}`)
          .then((data) => {
            console.log('syncCallBackView', data)
            if (data.payload) {
              this.$emit('close', data.payload.item1)
              this.clear()
            }
            self.Effects.loadComplete()
            resolve()
          }).catch((e) => {
            console.log('error', e)
            modals.showError(e.message)
            this.loadComplete()
          })
      })
    }
  }
}
</script>
<style scoped>
</style>
